export var MESSAGES = {
  EMAIL_NOT_CONFIRM:
    "\u0412\u0430\u0448 email \u043D\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D",
  EMAIL_CONFIRM:
    "\u0412\u0430\u0448 email \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D",
  PHONE_NOT_CONFIRM:
    "\u0412\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043D\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D",
  PHONE_CONFIRM:
    "\u0412\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D",
};
